// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToChainAfter } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    LoadRealTimePricing,
    SetProductInfo,
} from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/UpdateVariantSelection";

/**
 * XNG-Changes
 * Issue steps:
 * Go to https://west-fament-qa.xngage.net/Product/prd10206?option=568305. Notice the variant is 1/2 in
 * 1. Change the UoM to BX. Notice price updates to box price.
 * 2. Change the Variant to 3/4 in. Notice the UoM changes back to EA and the price updates accordingly
 * 3. Change the Variant back to 1/2 in
 * 4. The price shows the BX price, but the UoM is Each and the price text says Each.
 * If you change the UoM to BX then back to EA, it shows the correct price
 *
 * Description:
 * OOTB missing add LoadRealTimePricing to chain array
 * */
addToChainAfter(chain, SetProductInfo, LoadRealTimePricing);
